/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import NumberFormat from "react-number-format";

class Pay extends Component {
  state = {
    agree: false,
    chuchon: '',
    idConfirm: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    //this._getData()
    this._selectPayMethod('SC0010');
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async () => {
    const result = await this._getDataApi();
    if (result) {
      const intReturn = result.data[0].intReturn;
      const infoData = result.data[0].listData;

      //console.log(infoData)

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            infoData,
            payPrice: infoData[0].dcPrice,
            free: infoData[0].free,
            chuchonCode: infoData[0].chuchonCode,
          });
        }
      } else if (intReturn === -5) {
        toast.error('이미 보유한 멤버십이 존재합니다.');
        this._close();
      } else if (intReturn === -4) {
        toast.error('정기결제의 경우 해지 후 30일간 재가입이 제한됩니다.');
        this._close();
      } else if (intReturn === -3) {
        toast.error('이미 유효한 정기결제 건이 존재합니다.');
        this._close();
      } else if (intReturn === -2) {
        toast.error('정기결제 코드가 정확하지 않습니다.');
        this._close();
      } else {
        toast.error('존재하지 않는 상품입니다.');
        this._close();
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    const { freePassSerial, payMethod } = this.props.childProps;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log('===============')
    //console.log(payMethod)

    return axios
      .post(
        apiUrl + '/payInfoAuto',
        {
          params: {
            userid: loginId,
            authId: authId,
            freePassSerial: freePassSerial,
            payType:
              payMethod === 'SC0010' ? 'C' : payMethod === 'SC0060' ? 'P' : 'C',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._getData();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  _selectPayMethod = (payMethod) => {
    const { selectPayMethod } = this.props.childProps;

    selectPayMethod(payMethod);
    if (payMethod === 'SC0060') {
    }
    setTimeout(() => {
      this._getData();
    }, 300);
  };
  _changeCash = (values) => {
    const { infoData } = this.state;
    const { changeCash } = this.props.childProps;
    let useCash;
    if (
      values.value === '' ||
      values.value === undefined ||
      values.value === null
    ) {
      useCash = 0;
    } else {
      useCash = values.value;
    }

    if (infoData[0].remainCash < useCash) {
      toast.warn('보유하신 포인트가 부족합니다.');
    } else {
      if (infoData[0].dcPrice < useCash) {
        useCash = infoData[0].dcPrice;
      }
      changeCash(useCash);
    }

    const payPrice = infoData[0].dcPrice - useCash;

    this.setState({
      payPrice,
    });
  };
  _onPayment = () => {
    // const { loginId } = this.props;
    const { agree, chuchon, idConfirm } = this.state;
    const { onPayment, freePassSerial } = this.props.childProps;

    //console.log(chuchon)

    if (agree) {
      let chuchonUserid = '';
      if (idConfirm) {
        chuchonUserid = chuchon;
      } else {
        chuchonUserid = '';
      }
      onPayment(freePassSerial, chuchonUserid);
    } else {
      toast.warn('매월 자동결제에 동의해 주세요.');
    }
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _close = () => {
    const { onCloseAlert } = this.props.childProps;
    onCloseAlert();
  };
  _changeAgree = (e) => {
    //console.log(e.target.checked)
    this.setState({
      agree: e.target.checked,
    });
  };
  _change = (e) => {
    this.setState({
      chuchon: e.target.value,
    });
  };
  _checkUserid = async () => {
    const { loginId } = this.props;
    const { chuchon, chuchonCode } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요');
    } else {
      if (chuchon === null || chuchon === undefined || chuchon === '') {
        toast.warn('추천 코드를 입력해 주세요.');
        return false;
      }

      if (chuchonCode === chuchon) {
        toast.warn('본인을 추천인으로 등록할 수 없습니다.');
      } else {
        const result = await this._checkUseridApi();
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('추천코드가 확인되었습니다.');
          this.setState({
            idConfirm: true,
          });
        } else if (intReturn === -1) {
          toast.warn('일치하는 코드가 존재하지 않습니다.');
          this.setState({
            chuchon: '',
          });
        } else if (intReturn === -2) {
          toast.warn('추천코드를 이미 사용하셨습니다.(1인 1회만 가능).');
          this.setState({
            chuchon: '',
          });
        }
      }
    }
  };
  _checkUseridApi = () => {
    const { apiUrl, loginId } = this.props;
    const { chuchon } = this.state;

    return axios
      .post(apiUrl + '/chuchonCheck', {
        params: {
          buyUserid: loginId,
          chuchonUserid: chuchon,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _reTyping = () => {
    this.setState({
      chuchon: '',
      idConfirm: false,
    });
  };
  render() {
    const { infoData, agree, chuchon, idConfirm } = this.state;
    const { payMethod } = this.props.childProps;
    return (
      <Fragment>
        <div className="cashcard_close" style={{ paddingTop: 50 }}>
          <a style={{ cursor: 'pointer' }} onClick={this._close}>
            닫기
          </a>
        </div>
        <div className="cashcard_pop_layer6">
          <div className="cashcard_pop_top2">
            <div className="member01">
              <img src="img/cashcard/member01.png" />
            </div>
            <div className="evn_bg">
              <img src="img/cashcard/pop_bg.png" />
            </div>
          </div>
          <div className="cashcard_pop_content">
            <h2 className="cashcard_pop_h2_style1">결제내용</h2>
            <table
              width="100%"
              border="0"
              cellSpacing="0"
              cellPadding="0"
              className="cashcard_pop_table2"
            >
              <tbody>
                <tr>
                  <th>상품명</th>
                  <td className="cashcard_pop_table2_text2">
                    {infoData ? infoData[0].freePassName : null}
                    {infoData ? (
                      infoData[0].free === 'Y' && infoData[0].dcPrice === 0 ? (
                        <span>(첫달무료)</span>
                      ) : infoData[0].free === 'Y' &&
                        infoData[0].dcPrice === 12900 ? (
                        <span>
                          (휴대폰 결제는 PG사 사정에 의해 첫달무료가 제공되지
                          않습니다.)
                        </span>
                      ) : (
                        <span></span>
                      )
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="cashcard_pop_table2_text">
                    총결제 금액{' '}
                    <strong>
                      {infoData ? this._CommaFormatted(infoData[0].dcPrice) : 0}
                      원
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ height: 30 }}></div>
            <h2 className="cashcard_pop_h2_style1">추천인 코드</h2>

            <div className="chuchon_padding">
              <h1>
                추천코드
                <span>
                  애니플러스 정개결제시 추천하신 분과 추천받으시는 분께 각 1,000
                  포인트가 지급됩니다.
                </span>
              </h1>

              <ul className="radius2">
                <li className="on">
                  <input
                    name="chuchon"
                    maxLength={30}
                    type="text"
                    className="common_input login_input"
                    value={chuchon}
                    readOnly={idConfirm ? true : false}
                    placeholder="추천인 코드를 입력하세요."
                    onChange={this._change}
                  />
                  {idConfirm ? (
                    <input
                      type="button"
                      value="재입력"
                      className="common_input input_btn"
                      onClick={this._reTyping}
                    />
                  ) : (
                    <input
                      type="button"
                      value="확인"
                      className="common_input input_btn"
                      onClick={this._checkUserid}
                    />
                  )}
                </li>
              </ul>
            </div>

            <div style={{ height: 30 }}></div>
            <h2 className="cashcard_pop_h2_style1">결제수단</h2>
            <div className="img_btn_a">
              <a
                onClick={() => this._selectPayMethod('SC0010')}
                style={{ cursor: 'pointer' }}
              >
                {payMethod === 'SC0010' ? (
                  <img src="img/cashcard/btn_payment01_o.png" />
                ) : (
                  <img src="img/cashcard/btn_payment01.png" />
                )}
              </a>
              {/*
                                    <a onClick={()=>this._selectPayMethod('SC0060')} style={{ cursor: 'pointer'}}>
                                        {payMethod === 'SC0060' ? <img src="img/cashcard/btn_payment02_o.png"/> : <img src="img/cashcard/btn_payment02.png"/>}
                                    </a>
                                    */}
            </div>
            <div className="chek_gyeoljesudan">
              <input
                name="checkbox_1"
                id="checkbox_1"
                type="checkbox"
                checked={agree}
                onChange={this._changeAgree}
                className="checkbox_img"
                style={{ zIndex: 999, float: 'left' }}
              />
              <label htmlFor="checkbox_1">매월 자동결제에 동의합니다.</label>
            </div>
            <a style={{ cursor: 'pointer' }} onClick={this._onPayment}>
              결제하기
            </a>
          </div>
        </div>

        {/*
                    <div>s
                        <div>구매</div>
                        {freePassSerial === 10 ? (
                            <Fragment>
                            <div>보유포인트: {infoData[0].remainCash}</div>
                            <div>포인트 사용: 
                                <NumberFormat value={useCash} thousandSeparator={true} suffix={'원'} onValueChange={(values)=>this._changeCash(values)}  />
                            </div>
                            </Fragment>
                        ) : null }
                        <div>
                            총 결제금액 : <NumberFormat value={payPrice} displayType={'text'} thousandSeparator={true} suffix={'원'}/>
                            적립포인트: {infoData[0].saveCash}
                            결제방식 : <span onClick={()=>this._selectPayMethod('SC0010')}>카드</span>|<span onClick={()=>this._selectPayMethod('SC0060')}>휴대폰</span>|<span onClick={()=>this._selectPayMethod('SC0030')}>계좌이체</span>|<span onClick={()=>this._selectPayMethod('SC0111')}>상품권</span>
                        </div>
                        <div onClick={this._onPayment}>결제하기</div>
                    </div>
                    */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Pay));
